import { render, staticRenderFns } from "./salesdata.vue?vue&type=template&id=c0493ccc&scoped=true&"
import script from "./salesdata.vue?vue&type=script&lang=js&"
export * from "./salesdata.vue?vue&type=script&lang=js&"
import style0 from "./salesdata.vue?vue&type=style&index=0&id=c0493ccc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0493ccc",
  null
  
)

export default component.exports